import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConcurrentRequestHandlingService } from '@modules/common/services/concurrent-request-handling.service';
import { ApiProxyOptions } from '@modules/common/models/api-proxy-options';
import { AdminPortalStylingViewModel } from './admin-portal-styling-view-model.generated';

@Injectable({
    providedIn: 'root'
})
export class GetStylingService {
    constructor(private _concurrentRequestHandlingService: ConcurrentRequestHandlingService) { }

    public getStyling(options?: ApiProxyOptions): Observable<AdminPortalStylingViewModel> {
        return this._concurrentRequestHandlingService.callApi<AdminPortalStylingViewModel>(
            "GetStylingService_getStyling",
            {
                url: '/AdminPortalConfig/GetStyling/GetStyling',
                body: {},
                sendCredentials: true
            }, options
        );
    }
}
